<script>
	// Stores
	import UserStore from '@/Stores/UserStore.js';
	// Components
	import Editable from '@/Components/Editable.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let user;
	export let canEdit = false;

	function onClick(message) {
		if (message !== user.message) {
			UserStore.updateWarningMessage(user.id, message)
				.then(() => {
					notify({
						type: 'success',
						title: 'Warning Message',
						message: 'Warning Message updated',
						timeout: 3
					});
				})
				.catch((e) => {
					notify({
						type: 'danger',
						title: 'Error!',
						message: (e.error && e.error[0]) || 'Failed to update Warning Message',
						timeout: 5
					});
				});
		}
	}
</script>

<div class="px-2 py-1 text-sm font-semibold text-white bg-red-600">
	{#if canEdit}
		<Editable {onClick} text={user.message || 'Click to add warning'} className="justify-center" />
	{:else}
		<div class="text-center">{user.message || 'No warning'}</div>
	{/if}
</div>
